module.exports = __webpack_public_path__ + "media/images/flags/PE-72f434b8b9b916623880269bdb0dba62.svg";